module.exports = __webpack_public_path__ + "static/media/spinner.8ff93af5.svg";